import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';

import { setSearchDto } from "reducers/dto.slice";

import Loading from "components/shared/Loading";

const PAGE_SIZE = 50;

const Paging = () => {

    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const resultsDto = useAppSelector(x => x.dtos.resultDtoBase);
    const getMethod = useAppSelector(state => state.dtos.getMethod);
    const isLoading = useAppSelector(x => x.invoices.loading || x.orders.loading || x.cases.loading || x.returns.loading || x.creditMemos.loading);

    const dispatch = useAppDispatch();

    const onPageClick = (page: number) => {
        const newSearchDto = { ...searchDto, page: page };
        dispatch(setSearchDto(newSearchDto));
        if(getMethod)
            dispatch(getMethod(newSearchDto));
    }

    const showEnd = Math.min(resultsDto.offset + PAGE_SIZE, resultsDto.totalResults);
    const hasNextPage = resultsDto.offset + PAGE_SIZE < resultsDto.totalResults;

    if (resultsDto.totalResults === 0 && !isLoading) return null;

    return (
        <>
            {resultsDto.totalResults > 0 ?
                <div className="d-flex justify-content-between">
                    <div className="mt-4">
                        <span className="ms-1 mt-0">
                            Showing {resultsDto.offset + 1} - {showEnd} of {resultsDto.totalResults}
                        </span>
                    </div>
                    <Loading />
                    <div className="mt-3 text-end">
                        <Pagination size="sm" className="bcd-mb-0" aria-label="Table pagination">
                            <PaginationItem disabled={searchDto.page <= 0 || isLoading}>
                                <PaginationLink
                                    first
                                    onClick={() => onPageClick(0)}
                                >
                                    <FontAwesomeIcon icon='angles-left' className="me-2" />
                                    First
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={searchDto.page <= 0 || isLoading}>
                                <PaginationLink
                                    previous
                                    onClick={() => onPageClick(searchDto.page - 1)}
                                >
                                    <FontAwesomeIcon icon='angle-left' className="me-2" />
                                    Prev
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={!hasNextPage || isLoading}>
                                <PaginationLink
                                    next
                                    onClick={() => onPageClick(searchDto.page + 1)}
                                >
                                    Next
                                    <FontAwesomeIcon icon='angle-right' className="ms-2" />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={!hasNextPage || isLoading}>
                                <PaginationLink
                                    last
                                    onClick={() => onPageClick(Math.ceil(resultsDto.totalResults / PAGE_SIZE) - 1)}
                                >
                                    Last
                                    <FontAwesomeIcon icon='angles-right' className="ms-2" />
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </div>
                </div>
                :
                <div className="d-flex justify-content-center">
                    <Loading />
                </div>
            }
        </>
    );
}

export default Paging;